import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function InfinexIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M5.6 16h7.2V9.6h4V20H1.6V4h4z" />
        <path d="M22.4 20h-4V8h-7.2v6.4h-4V4h15.2z" />
      </>
    </Icon>
  );
}

InfinexIcon.displayName = 'InfinexIcon';
